import { memo } from 'react'

import {
  useGetWebhookSecret,
  useRegenerateWebhookSecret,
} from '~/hooks/query/settings'
import { WebhookSecretSection } from './components/WebhookSecret'

export const WebhookSecretBlock = memo(() => {
  const { data, isLoading } = useGetWebhookSecret()

  const webhookSecret = data?.webhook_secret

  const {
    mutate: regenerateWebhookSecret,
    isLoading: isRegeneratingWebhookSecret,
  } = useRegenerateWebhookSecret()

  const isLoadingOrRegeneratingWebhookSecret =
    isLoading || isRegeneratingWebhookSecret
  return (
    <div className="m-auto flex w-[900px] flex-col items-start">
      <WebhookSecretSection
        onRegenerate={regenerateWebhookSecret}
        secret={webhookSecret}
        isLoading={isLoadingOrRegeneratingWebhookSecret}
      />
    </div>
  )
})
